<script>
import WangEditor from "wangeditor";
import LaTeXEditorModal from "./laTeXEditorModal.vue";

export default {
  name: "questionOptionModal",
  components: { LaTeXEditorModal },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    info: Object,
  },
  model: {
    prop: "visible",
    event: "visible",
  },
  data() {
    return {
      form: {
        itemTitle: "",
        isRightChoice: false,
        score: 0,
        displayOrder: 0,
      },
      editor: null,
      laTeXEdit: {
        visible: false,
      },
    };
  },
  watch: {
    visible(bool) {
      if (bool) {
        this.form = this.info;
        this.initWangEditor();
      }
    },
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy(); // 组件销毁时，及时销毁编辑器
    }
  },
  methods: {
    modalOk() {
      this.form.itemTitle = this.editor.txt.html();
      this.$emit("visible", false);
      this.$emit("ok", this.form);
    },
    modalCancel() {
      this.$emit("visible", false);
    },
    initWangEditor() {
      this.$nextTick(() => {
        if (!this.editor) {
          const that = this;
          this.editor = new WangEditor(this.$refs.wangEditorBox);
          this.editor.config.height = 200;
          this.editor.config.showFullScreen = false;
          this.editor.config.showLinkImg = false;
          this.editor.config.uploadImgShowBase64 = true;
          this.editor.config.excludeMenus = ["video"];

          class MathJax extends WangEditor.BtnMenu {
            // 公式输入插件
            constructor(editors) {
              const $elem = WangEditor.$(
                `<div data-title="编写公式" class="w-e-menu"><i class="iconfont icon-shujujuzhen" style="font-size:18px;font-weight: bold;"></i></div>`,
              );
              super($elem, editors);
            }

            // 菜单点击事件
            clickHandler() {
              that.laTeXEdit.visible = true;
            }

            tryChangeActive() {

            }
          }

          this.editor.menus.extend("mathJax", MathJax);
          this.editor.config.menus.push("mathJax");
          this.editor.create();
        }
        this.editor.txt.html(this.info.itemTitle);
      });
    },
    rightChoiceChange() {
      if (!this.form.isRightChoice) {
        this.form.score = 0;
      }
    },
    laTeXEditorOk(val) {
      this.form.itemTitle = val;
    },
  },
};
</script>

<template>
  <a-modal title="编辑选项" :visible="visible" @ok="modalOk" @cancel="modalCancel" width="800px" centered>
    <a-form-model :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
      <a-form-model-item label="选项名称">
        <div class="wang-editor" ref="wangEditorBox"></div>
      </a-form-model-item>
      <a-form-model-item label="分值" v-if="form.itemType === 0">
        <a-input-number v-model="form.score" :disabled="!form.isRightChoice" type="number" :min="0" :max="9999" :step="1" />
      </a-form-model-item>
      <a-form-model-item label="是否正确" v-if="form.itemType === 0">
        <a-switch v-model="form.isRightChoice" @change="rightChoiceChange">
          <a-icon slot="checkedChildren" type="check" />
          <a-icon slot="unCheckedChildren" type="close" />
        </a-switch>
      </a-form-model-item>
      <a-form-model-item label="排序">
        <a-input-number v-model="form.displayOrder" type="number" :min="0" :max="999" :step="1" />
      </a-form-model-item>
    </a-form-model>
    <la-te-x-editor-modal v-model="laTeXEdit.visible" @click="laTeXEditorOk" />
  </a-modal>
</template>

<style scoped lang="less">
/deep/ .wang-editor > div {
  z-index: 2 !important;
}
</style>
